import React, { Component, Fragment } from 'react';
import Breadcrumb from '../common/breadcrumb';
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import Swal from "sweetalert2";
import moment from "moment";
import { Empty, Modal, Spin } from "antd";
import { Table, Tbody, Td, Th, Thead, Tr } from "react-super-responsive-table";
import { convertToRupiah, pageNumber } from "../../functions/functionGeneral";
import presensiHeaderModalBG from "../../assets/images/modal_header_bg.png";
import presensiWhiteLogo from "../../assets/images/presensi_white_logo.png";
import Paging from "../paging";
import html2canvas from "html2canvas";
import pdfMake from "pdfmake";
import { Input, Label } from "reactstrap";
import {set_auth} from "../../reducers/Auth";
import {set_filter} from "../../reducers/Filter"
import {hitungBiayaAdmin} from "../../helper/money";

export class Langganan extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data: [],
            data_invoice: [],
            perusahaan: [],
            langganan: [],
            paket: [],
            metode_bayar: '',
            idDel: '',
            renew_month: '',
            upgrade_month: '',
            upgrade_paket: null,
            modalItem: null,
            potongan_sisa_data: null,
            modalDetail: false,
            pageCount: 0,
            currentPage: 0,
        }

        this.handlePageClick = this.handlePageClick.bind(this)
        this.handleChange = this.handleChange.bind(this);
    }

    handleOk = e => {
        this.setState({
            modalDetail: false,
        });
    };

    handleCancel = e => {
        this.setState({
            modalDetail: false,
        });
    };

    handlePageClick(data) {
        let selected = data.selected; // zero based index
        this.setState({ currentPage: selected, loading: true }, () => {
            this.loadDataInvoice();
        });
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        })
    }

    bayarTagihan = (item) => {
        let form = {
            invoice_no: item.invoice_no,
            type: this.state.metode_bayar,
        }
        this.props.request("paket/pay", form, 'POST')
            .then(response => {
                if(response.failed) {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning',
                        showConfirmButton: false,
                        timer: 1200,
                    })
                }else{
                    window.location.replace(response)
                }
            });
    }

    printInvoice = () => {
        html2canvas(document.getElementById("invoicecontent")).then(canvas => {
            var data = canvas.toDataURL();
            var pdfExportSetting = {
                content: [
                    {
                        image: data,
                        width: 500
                    }
                ]
            };
            pdfMake.createPdf(pdfExportSetting).download("Invoice_Presensi_" + this.state.modalItem.invoice_no + '.pdf');
        });
    };

    wantPaket() {
        Swal.fire({
            title: 'Pemberitahuan!',
            text: 'Anda yakin ingin mengganti paket?',
            icon: 'warning',
            confirmButtonText: 'Ya',
            showCancelButton: true,
            cancelButtonText: 'Batal',
        })
            .then((result) => {
                if (result.isConfirmed) {
                    this.setState({
                        loading: true,
                        data: []
                    })
                    let form = {
                        paket_id: this.state.upgrade_paket.paket_id,
                        month: this.state.upgrade_month,
                    }
                    this.props.request("paket/update_paket", form, 'POST')
                        .then(response => {
                            if (response.success) {
                                Swal.fire({
                                    title: 'Berhasil!',
                                    text: response.message,
                                    icon: 'success',
                                    showConfirmButton: false,
                                    timer: 800,
                                })
                                this.setState({
                                    loading: false,
                                    modalUpgrade: false,
                                    upgrade_month: '',
                                    data: []
                                })
                                window.location.reload();
                            } else {
                                Swal.fire({
                                    title: 'Gagal!',
                                    text: response.message,
                                    icon: 'warning',
                                    showConfirmButton: false,
                                    timer: 1200,
                                })
                                this.setState({
                                    loading: false,
                                    modalUpgrade: false,
                                    upgrade_month: '',
                                    data: []
                                })
                            }
                        });
                }
            })
    }

    renewPaket() {
        Swal.fire({
            title: 'Pemberitahuan!',
            text: 'Anda yakin ingin memperpanjang paket?',
            icon: 'warning',
            confirmButtonText: 'Ya',
            showCancelButton: true,
            cancelButtonText: 'Batal',
        })
            .then((result) => {
                if (result.isConfirmed) {
                    this.setState({
                        loading: true,
                        data: []
                    })
                    let form = {
                        paket_id: this.state.langganan.paket.paket_id,
                        month: this.state.renew_month,
                    }
                    this.props.request("paket/perpanjang-paket", form, 'POST')
                        .then(response => {
                            if (response.success) {
                                let form = {
                                    page: 1,
                                }
                                this.props.request("get_invoice", form, 'POST')
                                    .then(response => {
                                        if (response.success) {
                                            this.setState({
                                                data_invoice: response.data.data,
                                                loading: false,
                                            })
                                            this.setState({
                                                modalRenew: false,
                                                modalDetail: true,
                                                modalItem: this.state.data_invoice[0]
                                            })
                                        }
                                    });
                            } else {
                                Swal.fire({
                                    title: 'Gagal!',
                                    text: response.message,
                                    icon: 'warning',
                                    showConfirmButton: false,
                                    timer: 1200,
                                })
                                this.setState({
                                    loading: false,
                                    data: []
                                })
                            }
                        });
                }
            })
    }

    stopLangganan() {
        Swal.fire({
            title: 'Pemberitahuan!',
            text: 'Anda yakin ingin menghentikan langganan?',
            icon: 'warning',
            confirmButtonText: 'Ya',
            showCancelButton: true,
            cancelButtonText: 'Batal',
        })
            .then((result) => {
                if (result.isConfirmed) {
                    this.setState({
                        loading: true,
                    })
                    let form = {
                    }
                    this.props.request("stop-langganan", form, 'POST')
                        .then(response => {
                            if (response.success) {
                                Swal.fire({
                                    title: 'Berhasil!',
                                    text: response.message,
                                    icon: 'success',
                                    showConfirmButton: false,
                                    timer: 800,
                                })
                                this.setState({
                                    loading: false,
                                    data: []
                                })
                                this.props.clear_auth();
                                window.location.reload();
                            } else {
                                Swal.fire({
                                    title: 'Gagal!',
                                    text: response.message,
                                    icon: 'warning',
                                    showConfirmButton: false,
                                    timer: 1200,
                                })
                                this.setState({
                                    loading: false,
                                    data: []
                                })
                            }
                        });
                }
            })
    }

    loadPaket() {
        let form = {}
        this.props.request("paket/list", form, 'POST')
            .then(response => {
                if (response.success) {
                    this.setState({
                        paket: response.data.data,
                        loading: false,
                    })
                }

            });
    }

    loadData() {
        this.setState({ loading: true })
        let form = {}
        this.props.request("dashboard", form, 'POST')
            .then(response => {
                if (response.success) {
                    var langganan = response.expired_date
                    this.setState({
                        data: response,
                        langganan: langganan
                    })
                }
                this.setState({ loading: false })

            });

    }

    loadDataUser() {
        this.setState({
            loading: true
        })
        let form = {}
        this.props.request("get_company", form, 'POST')
            .then(response => {
                if (response) {
                    this.props.set_auth(response.user.api_token, response.user, response.all_data);
                    this.props.set_filter(response.all_data);
                    this.setState({
                        data_user: response.data,
                        upgrade_paket: response.upgrade_paket,
                        karyawan_status: response.karyawan,
                        jumlah_karyawan: response.jumlah_karyawan,
                        max_karyawan: response.maks_karyawan,
                    })

                }
            })
        this.setState({
            loading: false
        })
    }

    loadDataInvoice() {
        let form = {
            page: this.state.currentPage + 1,
        }
        this.props.request("get_invoice", form, 'POST')
            .then(response => {
                if (response.success) {
                    this.setState({
                        data_invoice: response.data.data,
                        perusahaan: response.perusahaan,
                        totalData: response.data.total,
                        pageCount: response.data.last_page,
                        perPage: response.data.per_page,
                        potongan_sisa_data: response.data.data.potongan_sisa,
                        loading: false
                    })
                } else {
                    this.setState({
                        data: null
                    })
                }
            });
    }

    componentDidMount() {
        this.loadData()
        this.loadPaket()
        this.loadDataUser()
        this.loadDataInvoice()
    }

    render() {
        let no = 0;
        if (this.props.user.user_level.level_page_limited == null || this.props.user.user_level.level_page_limited.search("Langganan") >= 0) {
            return (
                <Fragment>
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>Langganan - Presensi</title>
                        <meta name="description" content="Detail Paket" />
                    </Helmet>
                    <Breadcrumb title="Langganan" setGuide={() => { this.setState({ guide: true }) }} />
                    <div className="container-fluid list-paket">
                        <section id="harga" className="section-lr feature-section mb-5">
                            <div className="container-fluid">
                                {this.state.langganan && this.state.langganan.langganan_status === "pending" || this.state.langganan.langganan_status === "expired" ? (
                                    <div className="alert alert-warning" role="alert">
                                        Langganan anda telah Berakhir. Perusahaan dalam Kondisi Pending. Segera Lakukan Pembayaran Invoice
                                        {this.state.data_invoice.length > 0 ? (
                                            <a onClick={() => { this.setState({ modalDetail: true, modalItem: this.state.data_invoice[0] }) }}><b> #{this.state.data_invoice[0].invoice_no} </b></a>
                                        ) : " "}
                                        untuk mengakses Seluruh Fitur Presensi.
                                    </div>
                                ) : null}
                                <div className="row">
                                    <div className=" col">
                                        <div className="card mb-2 ">
                                            <div className="card-body" >
                                                <div className="media-body">
                                                    <div className="row mb-lg-4 mb-sm-0">
                                                        <div className="col">
                                                            <div className="mb-2">
                                                                {this.state.langganan.paket_nama &&
                                                                    <div className="row" style={{margin: "auto"}}>
                                                                        <span className="bg-blue-dark text-white p-1 rounded">
                                                                            <strong>{this.state.langganan.paket_nama.toUpperCase()}</strong>
                                                                        </span>
                                                                        {this.props.user && this.props.user.perusahaan.langganan && this.props.user.perusahaan.langganan.paket.paket_premium == "1" &&
                                                                            <span className="bg-red text-gold p-1 ml-1 rounded">
                                                                                <strong>PREMIUM+</strong>
                                                                            </span>
                                                                        }
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div>
                                                                <span>Berakhir pada&nbsp;</span>
                                                                <strong>
                                                                    {moment(this.state.langganan && this.state.langganan.langganan_expired_date).format('ll')}
                                                                </strong>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            {this.state.langganan && this.state.langganan.paket &&
                                                                <span><sup>Rp</sup><strong className="fs-24">{convertToRupiah((this.state.langganan.paket.paket_harga / this.state.langganan.paket.paket_bulan))}</strong><sup className="text-disable">/bulan</sup></span>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="mt-lg-4 mt-sm-2">
                                                        <h6>Karyawan Maksimal<span
                                                            className="pull-right">{this.state.jumlah_karyawan} / {this.state.max_karyawan} ({this.state.karyawan_status && this.state.karyawan_status.toFixed(2)}%)</span>
                                                        </h6>
                                                        <div className="progress lg-progress-bar">
                                                            <div className="progress-bar bg-primary" role="progressbar"
                                                                 style={{ width: this.state.karyawan_status + '%' }}
                                                                 aria-valuenow="25" aria-valuemin="0"
                                                                 aria-valuemax="100"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <a onClick={() => { this.stopLangganan() }}><u className="text-secondary">Berhenti Berlangganan</u></a>
                                            </div>
                                            <div className="col">
                                                <a className="btn btn-outline-custom-none bg-yellow btn-block" onClick={() => { this.setState({ modalRenew: true }) }}>Perpanjang Paket</a>
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.upgrade_paket ?
                                        <div className="col">
                                            <div className="card bg-blue-dark">
                                                <div className="card-body" >
                                                    <div className="media-body">
                                                        <span className="text-white">
                                                            <strong>Upgrade paketmu ke {this.state.upgrade_paket.paket_nama} dan dapatkan Max {this.state.upgrade_paket.paket_jumlah} karyawan hanya dengan {convertToRupiah(this.state.upgrade_paket.paket_harga / this.state.upgrade_paket.paket_bulan, true)}/bulan</strong>
                                                        </span>
                                                        <p className="text-white mt-2">{this.state.upgrade_paket.paket_nama} sesuai untuk {this.state.upgrade_paket.paket_desc}</p>
                                                        <div className="row">
                                                            <div className="col mb-2">
                                                                <a className="btn btn-outline-custom-none bg-white btn-block text-dark" href={"/langganan/paket"}>Lihat paket lainnya</a>
                                                            </div>
                                                            <div className="col">
                                                                <a className="btn btn-outline-custom-none bg-yellow btn-block" onClick={() => { this.setState({ modalUpgrade: true }) }}>Upgrade ke {this.state.upgrade_paket.paket_nama}</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className="col">
                                            <div className="card bg-blue-dark">
                                                <div className="card-body">
                                                    <div className="media-body">
                                                        <span className="text-white">
                                                            <strong>Paket yang anda gunakan adalah paket tertinggi dengan Max 500 Karyawan.</strong>
                                                        </span>
                                                        <p className="text-white mt-2"> Sesuai {this.props.user.perusahaan.langganan.paket.paket_desc}</p>
                                                        <div className="row">
                                                            <div className="col mb-2">
                                                                <a className="btn btn-outline-custom-none bg-white btn-block text-dark" href={"/langganan/paket"}>Lihat paket lainnya</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="card profile-card mt-2">
                                    <div className="card-body">
                                        {!this.state.isLoading && this.state.data_invoice.length === 0 ?
                                            <Empty
                                                image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                                                imageStyle={{ height: 60 }}
                                                description={<span>Invoice Kosong!</span>}
                                            />
                                            :
                                            <div>
                                                <Table striped className="mb-5" id="list-invoice">
                                                    <Thead>
                                                        <Tr>
                                                            <Th width="30" height={50}>#</Th>
                                                            <Th >Hari/Tanggal</Th>
                                                            <Th className={"text-center"}>No. Invoice</Th>
                                                            <Th className={"text-center"}>Paket</Th>
                                                            <Th className={"text-center"}>Tagihan</Th>
                                                            <Th className={"text-center"}>Status</Th>
                                                            <Th></Th>
                                                        </Tr>
                                                    </Thead>
                                                    <Tbody>
                                                        {this.state.data_invoice.map((item, index) => {
                                                            no += 1
                                                            return (
                                                                <Tr className="border-bottom-light">
                                                                    <Td height={50}>
                                                                        <small>
                                                                            <Th scope="row">{pageNumber(no, this.state.perPage, this.state.currentPage)}</Th>
                                                                        </small>
                                                                    </Td>
                                                                    <Td align="center"><span className="pb-2">{item.invoice_create_date}</span></Td>
                                                                    <Td align="center">#{item.invoice_no}</Td>
                                                                    <Td align="center">{item.paket.paket_nama}</Td>
                                                                    <Td align="center">{convertToRupiah(item.invoice_nominal, true)}</Td>
                                                                    <Td align="center"><span className={item.invoice_status == 'pending' ? "text-warning" : item.invoice_status == 'expired' ? "text-secondary" : "text-success"}>{item.invoice_status == 'pending' ? "Menunggu Pembayaran" : item.invoice_status == 'expired' ? "Kadaluarsa" : "Lunas"}</span></Td>
                                                                    <Td className={"text-right"}>
                                                                        {item.invoice_status == 'pending' ?
                                                                            <button className="btn btn-primary px-2" onClick={() => {
                                                                                this.setState({
                                                                                    modalDetail: true, modalItem: item
                                                                                })
                                                                            }}>Bayar</button>
                                                                            : <a onClick={() => {
                                                                                this.setState({
                                                                                    modalDetail: true, modalItem: item
                                                                                })
                                                                            }} className="text-primary">Detail</a>
                                                                        }
                                                                    </Td>
                                                                </Tr>
                                                            )
                                                        })}
                                                        {this.state.isLoading &&
                                                            <Tr>
                                                                <Td colSpan="3">
                                                                    <Spin style={{ width: '100%' }} size="small" tip="Mohon Tunggu..." />
                                                                </Td>
                                                            </Tr>
                                                        }
                                                    </Tbody>
                                                </Table>
                                                <Paging
                                                    className="float-right"
                                                    handlePageClick={this.handlePageClick}
                                                    pageCount={this.state.pageCount}
                                                    currentPage={this.state.currentPage}
                                                />
                                            </div>

                                        }
                                    </div>
                                </div>
                                <Modal
                                    title=""
                                    visible={this.state.modalDetail}
                                    onOk={this.handleOk}
                                    onCancel={this.handleCancel}
                                    footer={[
                                        this.state.modalItem && (
                                            <div className="row justify-content-between px-4">
                                                <button onClick={() => { this.printInvoice() }} className={'btn btn-outline-custom bg-primary'} style={{ textTransform: "none" }}><i className="fa fa-download" style={{ color: "white" }}/></button>
                                                <div>
                                                    {this.state.modalItem.invoice_status == 'pending' ?
                                                        <div className={"row"}>
                                                            <div className={"col-auto"}>
                                                                <select name="metode_bayar" className="form-control bg-white karyawan-filter-jabatan mr-1" onChange={this.handleChange}>
                                                                    <option value="">Pilih Metode Bayar</option>
                                                                    <option value="credit_card">Kartu Kredit</option>
                                                                    <option value="bank_transfer">Bank Transfer</option>
                                                                    <option value="shopeepay">ShopeePay</option>
                                                                    <option value="indomaret">Indomaret</option>
                                                                    <option value="alfamart">Alfamart</option>
                                                                    <option value="akulaku">Akulaku Paylater</option>
                                                                    <option value="other_qris">QRIS</option>
                                                                </select>
                                                            </div>
                                                            <button onClick={() => { this.bayarTagihan(this.state.modalItem) }} className={'btn ' + (this.state.metode_bayar ? 'bg-primary' : 'bg-disabled')} style={{ textTransform: "none" }} disabled={!this.state.metode_bayar}>Bayar Sekarang</button>
                                                        </div> : null
                                                    }
                                                </div>
                                            </div>
                                        )
                                    ]}
                                >
                                    <div className="mb-4"></div>
                                    {this.state.modalItem && (
                                        <div className="bg-white shadow pt-0 pr-3 pl-3 pb-3" id="invoicecontent">
                                            <div className="row bg-blue-dark p-2 text-white border-bottom-blue" style={{backgroundImage: `url(${presensiHeaderModalBG})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'left center'}}>
                                                <div className="col-4 d-flex align-items-center">
                                                    <img src={presensiWhiteLogo} alt="Logo" style={{ height: '26px'}}/>
                                                </div>
                                                <div className="col-8 text-right">
                                                    <b className={this.state.modalItem.invoice_success_date ? "text-success" : "text-white"}>{moment(this.state.modalItem.invoice_success_date ? this.state.modalItem.invoice_success_date : this.state.modalItem.invoice_create_date).format("dddd, MMMM Do YYYY")}</b><br />
                                                    <span>{this.state.perusahaan.perusahaan_nama}</span>
                                                </div>
                                            </div>
                                            <div className="row p-4">
                                                <div style={{ backgroundColor: this.state.modalItem.invoice_status == 'pending' ? '#FFF6E8' : this.state.modalItem.invoice_status == 'expired' ? '#F5F5F5' : '#E8F2E7', color: this.state.modalItem.invoice_status == 'pending' ? '#FF9C00' : this.state.modalItem.invoice_status == 'expired' ? '#5D6F80' : '#6BAA61', fontSize: 16, textTransform: "uppercase", fontWeight: "bold" }} className="w-100 text-center p-2">{this.state.modalItem.invoice_status == 'pending' ? "Menunggu Pembayaran" : this.state.modalItem.invoice_status == 'expired' ? "Kadaluarsa" : "Lunas"}</div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-8">
                                                    <h5 className="text-blue-dark"><b>{this.state.perusahaan.perusahaan_nama}</b></h5>
                                                    <span className="text-secondary">{this.state.perusahaan.perusahaan_alamat}</span>
                                                </div>
                                                <div className="col-4 text-right">
                                                    <h5 className="text-blue-dark"><b>INVOICE</b></h5>
                                                    <span className="text-secondary">#{this.state.modalItem.invoice_no}</span>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col">
                                                    <h6 className="text-secondary mb-0"><b>Ringkasan Biaya</b></h6>
                                                    <span>{this.state.modalItem.paket.paket_nama} ({this.state.modalItem.invoice_lama_bulan} Bulan)</span>
                                                </div>
                                                <div className="col text-right">
                                                    <h5 className="text-secondary mb-0"><b>Harga</b></h5>
                                                    <span>{convertToRupiah(this.state.modalItem.invoice_nominal, true)}</span>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col">
                                                    <h6 className="text-secondary mb-0"><b>Potongan Sisa</b></h6>
                                                </div>
                                                <div className="col text-right">
                                                    <span>{convertToRupiah(this.state.modalItem.potongan_sisa, true)}</span>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col">
                                                    <h6 className="text-secondary mb-0"><b>Biaya Admin</b></h6>
                                                </div>
                                                <div className="col text-right">
                                                    <span>{convertToRupiah(this.state.modalItem.invoice_status == 'pending' ? hitungBiayaAdmin(this.state.metode_bayar, this.state.modalItem.invoice_nominal) : hitungBiayaAdmin(this.state.modalItem.invoice_payment_type, this.state.modalItem.invoice_nominal), true)}</span>
                                                </div>
                                            </div>
                                            <div className="text-right mt-2 text-dark">
                                                <h5><b>Total {convertToRupiah(this.state.modalItem.invoice_nominal + (this.state.modalItem.invoice_status == 'pending' ? hitungBiayaAdmin(this.state.metode_bayar, this.state.modalItem.invoice_nominal) : hitungBiayaAdmin(this.state.modalItem.invoice_payment_type, this.state.modalItem.invoice_nominal)), true)}</b></h5>
                                            </div>
                                            <div className="text-center text-secondary bg-light">
                                                <span>Presensi.co.id @2025</span>
                                            </div>
                                        </div>
                                    )}
                                </Modal>
                                <Modal
                                    title="Pilih Durasi Perpanjangan Paket"
                                    visible={this.state.modalRenew}
                                    onOk={() => {
                                        this.setState({
                                            modalRenew: false,
                                        });
                                    }}
                                    onCancel={() => {
                                        this.setState({
                                            modalRenew: false,
                                        });
                                    }}
                                    footer={null}
                                >
                                    <div>
                                        <Label>Pilih Durasi Masa Aktif Perpanjangan Paket Perusahaan</Label><br />
                                        <Label style={{ fontSize: "9px", marginBottom: "1px" }}>(Pilih Bulan Masa Aktif) </Label>
                                        <Input bsSize="sm" type="select" name="renew_month" className="form-select w-50" value={this.state.renew_month} onChange={this.handleChange}>
                                            <option value="">Pilih Bulan</option>
                                            <option value="1">1 Bulan</option>
                                            <option value="2">2 Bulan</option>
                                            <option value="3">3 Bulan</option>
                                            <option value="4">4 Bulan</option>
                                            <option value="5">5 Bulan</option>
                                            <option value="6">6 Bulan</option>
                                            <option value="7">7 Bulan</option>
                                            <option value="8">8 Bulan</option>
                                            <option value="9">9 Bulan</option>
                                            <option value="10">10 Bulan</option>
                                            <option value="11">11 Bulan</option>
                                            <option value="12">12 Bulan</option>
                                        </Input>
                                        {!this.state.loading ?
                                            <a type="button" className="btn btn-primary mb-3 mt-3 text-center"
                                               style={{ color: 'white', maxWidth: '100%' }}
                                               onClick={() => {
                                                   this.renewPaket()
                                               }}>
                                                Perpanjang Paket
                                            </a>
                                            :
                                            <a type="button" className="btn btn-primary mb-3 mt-3 text-center"
                                               style={{ color: 'white', maxWidth: '100%' }}>
                                                <i className="fa fa-refresh fa-spin mr-2" />
                                                Sedang Memperpanjang Paket...
                                            </a>
                                        }
                                    </div>
                                </Modal>
                                <Modal
                                    title="Pilih Durasi Upgrade Paket"
                                    visible={this.state.modalUpgrade}
                                    onOk={() => {
                                        this.setState({
                                            modalUpgrade: false,
                                        });
                                    }}
                                    onCancel={() => {
                                        this.setState({
                                            modalUpgrade: false,
                                        });
                                    }}
                                    footer={null}
                                >
                                    <div>
                                        <Label>Pilih Durasi Masa Aktif Upgrade Paket Perusahaan</Label><br />
                                        <Label style={{ fontSize: "9px", marginBottom: "1px" }}>(Pilih Bulan Masa Aktif) </Label>
                                        <Input bsSize="sm" type="select" name="upgrade_month" className="form-select w-50" value={this.state.upgrade_month} onChange={this.handleChange}>
                                            <option value="">Pilih Bulan</option>
                                            <option value="1">1 Bulan</option>
                                            <option value="2">2 Bulan</option>
                                            <option value="3">3 Bulan</option>
                                            <option value="4">4 Bulan</option>
                                            <option value="5">5 Bulan</option>
                                            <option value="6">6 Bulan</option>
                                            <option value="7">7 Bulan</option>
                                            <option value="8">8 Bulan</option>
                                            <option value="9">9 Bulan</option>
                                            <option value="10">10 Bulan</option>
                                            <option value="11">11 Bulan</option>
                                            <option value="12">12 Bulan</option>
                                        </Input>
                                        {!this.state.loading ?
                                            <a type="button" className="btn btn-primary mb-3 mt-3 text-center"
                                               style={{ color: 'white', maxWidth: '100%' }}
                                               onClick={() => {
                                                   this.wantPaket()
                                               }}>
                                                Upgrade Paket
                                            </a>
                                            :
                                            <a type="button" className="btn btn-primary mb-3 mt-3 text-center"
                                               style={{ color: 'white', maxWidth: '100%' }}>
                                                <i className="fa fa-refresh fa-spin mr-2" />
                                                Sedang Mengupgrade Paket...
                                            </a>
                                        }
                                    </div>
                                </Modal>

                            </div>
                        </section>
                    </div>
                </Fragment>
            )
        } else {
            return (
                <Fragment>
                    <h5 className="text-center pt-4">Anda tidak punya akses ke halaman ini.</h5>
                </Fragment>
            )
        }
    }
}

const mapStateToProps = state => ({
    user: state.Auth.user,
    all_data: state.Filter.all_data,
    shift: state.Filter._sift
})
const mapDispatchToProps = dispatch => ({
    set_auth: (api_token, data) => dispatch(set_auth(api_token, data)),
    set_filter: (all_data, _sift) => dispatch(set_filter(all_data, _sift))
})

export default connect(mapStateToProps, mapDispatchToProps)(Langganan);
